import React, { useEffect, useState } from "react";
import VerActividades from "./InventarioActividadesComponents/VerActividades";
import CargarExcelCampo from "./InventarioActividadesComponents/CargaExcelCampo";
import HistorialDeActividades from "./InventarioActividadesComponents/HistorialDeActividades";
import ExcelCargados from "./InventarioActividadesComponents/ExcelCargados";
import { getWeekNumber } from "../../../utils/Common";
import generalTools from "../../sharecomponents/generalTools";
import { PHP_BACK } from "../../../utils/Common";
import GeneradorActividadesV2 from "./InventarioActividadesComponents/GeneradorActividadesV2";
import VerActividaesV2 from "./InventarioActividadesComponents/VerActividaesV2";
import axios from 'axios';

const InventarioActividades = () => {
  const [section, setsection] = useState(2);
  const [week, setweek] = useState('');
  const [fechaCargaInventario, setfechaCargaInventario] = useState('');
  useEffect(() => {
    let ww = getWeekNumber();
    let semana = ww[1] < 10 ? `0${ww[1]}` : ww[1];
    let anio = (`${ww[0] - 2000}`);
    setweek(`${anio}${semana}`);
    getFechaCargaCampo();
  }, [])

  const sectionButton = (seccion, text) => {
    let classname = seccion === section ? "btn btn-warning text-bold border border-dark m-2" : 'btn btn-light border shadow m-2';
    return (
      <button className={classname} style={{ maxWidth: '220px' }} onClick={() => { setsection(seccion) }}>{text}</button>
    );
  }

  const getFechaCargaCampo = () => {
    axios.get(PHP_BACK + "excel/regs/campo/ultimaCarga")
      .then((r) => {
        if (r.data && r.data.fecha.fecha) setfechaCargaInventario(r.data.fecha.fecha)
        else setfechaCargaInventario("");

      })
      .catch((e) => { console.log(e); });
  }

  return (
    <div className="w-100 h-100 gradient-blue-sky border round-m dosis shadow-lg p-0" style={{ overflow: "auto" }} >
      {/*<div className="vw-100 h-100 dosis gradient-blue-sky border round-m shadow-lg p-0">*/}
      <div className="w-100 m-0 p-0" id='contenedor_actividad_0' />
      <div className="border-b rounded-t p-2 bg-orange-800">
        <h5 className="font-bold uppercase text-white p-0 m-0">
          Inventario de Actividades
          <span className="text-s text-400 text-white ms-3">Semana: {week}</span>
          <span className="ms-3 text-xs text-400">Carga de inventario de campo:
            <span className="text-bold ms-1">{generalTools.formatDateTime(fechaCargaInventario)}</span>
          </span>
        </h5>
      </div>
      <div className='row justify-content-center wv-100 p-0 m-0'>
        {sectionButton(1, 'Ejecución de actividades')}
        {sectionButton(2, 'Planeación de actividades')}
        {sectionButton(3, 'Historial de actividades')}
        {sectionButton(4, 'Cargar plan de campo')}
        {sectionButton(5, 'Planes de campo cargados')}
      </div>

      {section === 1 && <VerActividaesV2 />}
      {section === 2 && <GeneradorActividadesV2 semanaActual={week} />}
      {section === 3 && <VerActividaesV2 historial={true} />}
      {section === 4 && <CargarExcelCampo actualizarFecha={getFechaCargaCampo} />}
      {section === 5 && <ExcelCargados actualizarFecha={getFechaCargaCampo} />}

    </div>
  );
}

export default InventarioActividades;
